import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC, useCallback, useState } from 'react'

import { EntityCardBody } from '@user/components/EntityCards/Body'
import { EntityCardDrawer } from '@user/components/EntityCards/Drawer'
import { ISalesFunnelCard } from '@user/store/salesFunnelSummary/typings'
import { ProjectedSales } from '../ProjectedSales'
import { SalesFunnelCardDrawer } from './SalesFunnelCardDrawer'
import { SalesFunnelCardFooter } from './SalesFunnelCardFooter'
import { SalesFunnelCardHeader } from './SalesFunnelCardHeader'
import { SalesFunnelCardMetrics } from './SalesFunnelCardMetrics'
import Grid from '@mui/material/Grid'
import { SalesFunnelCardWrapper } from '../SalesFunnelCardWrapper'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'

interface Props {
  funnel: ISalesFunnelCard
  handleClose: () => void
  handleManageClick: (status: SOLD_SERVICE_STATUS) => void
}

const getStyles = (theme: Theme) => ({
  item: {
    marginTop: theme.spacing(3.8),
    '@media (min-width: 960px)': {
      marginTop: theme.spacing(0),
    },
  },
})

export const SalesFunnelCard: FC<Props> = (props) => {
  const { funnel, handleClose } = props

  const {
    expectedOpportunitiesValue,
    percentageWon,
    projectedSalesTotalValue,
    salesFunnelId,
    salesFunnelName,
    wonOpportunitiesValue,
  } = funnel

  const [open, setOpen] = useState<boolean>(false)
  const toggleDrawer = useCallback(() => setOpen(!open), [open])
  const styles = getStyles(useTheme())
  return (
    <SalesFunnelCardWrapper>
      <SalesFunnelCardHeader funnel={funnel} />
      <EntityCardBody>
        <Grid container>
          <Grid item xs={12} lg={9}>
            <SalesFunnelCardMetrics funnel={funnel} handleClose={handleClose} />
          </Grid>

          {!!salesFunnelId && !!salesFunnelName && (
            <Grid item xs={12} lg={3} sx={styles.item}>
              <ProjectedSales
                closedWon={wonOpportunitiesValue}
                handleClose={handleClose}
                open={expectedOpportunitiesValue}
                percentageComplete={percentageWon}
                projected={projectedSalesTotalValue}
                salesFunnelId={salesFunnelId}
                salesFunnelName={salesFunnelName}
                soldServicesSummary={funnel.soldServiceDetails}
                type="detail"
              />
            </Grid>
          )}
        </Grid>
      </EntityCardBody>
      {!!salesFunnelId && !!salesFunnelName && (
        <>
          <SalesFunnelCardFooter
            handleOpenDrawer={toggleDrawer}
            isOpen={open}
            title="Funnel Stage Details"
          />
          <EntityCardDrawer isOpen={open}>
            <SalesFunnelCardDrawer
              funnelCard={funnel}
              handleClose={handleClose}
            />
          </EntityCardDrawer>
        </>
      )}
    </SalesFunnelCardWrapper>
  )
}

SalesFunnelCard.displayName = 'SalesFunnelCard'
